// src/api/v3/audit-log-entries-api-v3.js
import { authHeaders } from './_auth';
const API_BASE = process.env.REACT_APP_API_BASE;

async function handleRes(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const json = await res.json();
      msg = json?.errors?.join(', ') || json?.error || msg;
    } catch (_) {}
    throw new Error(msg);
  }
  return res.json();
}

const AuditLogEntriesAPI = {
  async list(params = {}) {
    const url = new URL(`${API_BASE}/api/v3/audit-log-entries`);
    Object.entries(params).forEach(([key, value]) => {
      if (value == null || value === '') return;
      url.searchParams.set(key, String(value));
    });

    const res = await fetch(url.toString(), {
      credentials: 'include',
      headers: { Accept: 'application/json', ...authHeaders() },
    });

    return handleRes(res);
  },
};

export default AuditLogEntriesAPI;